<div class="details-switcher">
  <fd-segmented-button [(ngModel)]="detailsSelected">
    <button fd-button label="Overview" value="form" id="form-btn"></button>
    <button
      fd-button
      label="YAML"
      value="yaml"
      id="yaml-btn"
      (click)="selectYaml()"
    ></button>
  </fd-segmented-button>
  <fd-toolbar style="background-color: transparent">
    @if (showCopyPath) {
      <button
        fd-button
        class="link-color"
        [fdCompact]="true"
        [fdType]="'transparent'"
        (click)="onCopyPath()"
      >
        Copy Path
      </button>
    }
    <button
      fd-button
      class="link-color"
      [fdCompact]="true"
      [fdType]="'transparent'"
      (click)="copyYaml()"
    >
      Copy YAML
    </button>
    @if (detailsSelected === "yaml") {
      @if (isEditable(resource)) {
        <button
          fd-button
          id="edit-with-yaml-btn"
          class="link-color"
          (click)="this.onEditResource.emit(false)"
          [fdCompact]="true"
          [fdType]="'transparent'"
          title="Edit YAML"
          label="Edit"
          i18n-title="
            XTOL|Tooltip of the Edit button@@editWithYAMLButtonTooltip"
          i18n-label="XBTN|Label of the Edit button@@editWithYAMLButtonLabel"
        ></button>
      }
      <button
        fd-button
        [fdCompact]="true"
        [fdType]="'transparent'"
        class="link-color"
        (click)="onExpandYaml()"
        label="Expand"
        title="Expand YAML"
      ></button>
      <button
        fd-button
        [fdCompact]="true"
        [fdType]="'transparent'"
        class="link-color"
        (click)="onCollapseYaml()"
        label="Collapse"
        title="Collapse YAML"
      ></button>
      @if (showFullScreen) {
        <app-full-screen-button
          selector="#app-editor"
          (clickEvent)="isYamlExpanded = $event"
        >
        </app-full-screen-button>
      }
    }
  </fd-toolbar>
</div>
<div class="details-component-container">
  <fd-busy-indicator [loading]="loading" size="m">
    @if (detailsSelected === "form") {
      <div class="details-form-box">
        <div class="general-info-container">
          <h3>General Info</h3>
          <app-details-row
            id="detailsApiVersion"
            label="API Version"
            [value]="resource?.apiVersion"
          ></app-details-row>
          <app-details-row
            id="detailsType"
            label="Type"
            [value]="resource?.type"
          ></app-details-row>
          <app-details-row
            id="detailsTechnicalName"
            label="Name"
            [value]="resource?.name"
          ></app-details-row>
          <div class="path-wrap">
            <app-details-row
              id="detailsPath"
              label="Path"
              [value]="resource?.path"
            ></app-details-row>
            <button
              fd-button
              fdType="transparent"
              class="copy-button link-color"
              (click)="onCopyPath()"
              i18n-title="
                XTOL|Tooltip for copy path button@@details.status.popover.title"
              title="Copy Path"
            >
              <app-icon icon="copy" size="1x"></app-icon>
            </button>
          </div>
          @if (resource?.description) {
            <app-details-row
              id="detailsDescription"
              label="Description"
              [value]="resource?.description"
            ></app-details-row>
          }
          @if (details?.spec?.provisioning) {
            <div>
              @if (provisioningMethod && provisioningMethod.length > 0) {
                <app-details-row
                  id="detailsProvisioningMethod"
                  label="Provisioning Method"
                  [value]="provisioningMethod"
                ></app-details-row>
              }
              @if (!!details?.spec?.provisioning?.callback?.url) {
                <app-details-row
                  id="detailsProvisioningUrl"
                  label="Callback URL"
                  [value]="details?.spec?.provisioning?.callback?.url"
                ></app-details-row>
              }
            </div>
          }
          <app-details-row
            id="detailsCreatedOn"
            label="Created On"
            [tooltip]="resource?.creationTime | customDate: 'long'"
            [value]="resource?.creationTime | customDate: ''"
          ></app-details-row>
          @if (resource?.modificationTime) {
            <app-details-row
              id="detailsModifiedOn"
              label="Modified On"
              [tooltip]="resource?.modificationTime | customDate: 'long'"
              [value]="resource?.modificationTime | customDate: ''"
            ></app-details-row>
          }
          @if (resource?.resource?.metadata?.lastTouchedTime) {
            <app-details-row
              id="detailsTouchedTime"
              label="Last Touched Time"
              [tooltip]="
                resource?.resource?.metadata?.lastTouchedTime
                  | customDate: 'long'
              "
              [value]="
                resource?.resource?.metadata?.lastTouchedTime | customDate: ''
              "
            ></app-details-row>
          }
          <app-details-row
            id="detailsGeneration"
            label="Generation"
            [value]="resource?.resource?.metadata?.generation"
          ></app-details-row>
        </div>
        @if (!!details?.stringData) {
          <div class="stringdata-container">
            <h3>String Data</h3>
            @for (item of details?.stringData | keyvalue; track item) {
              <app-details-row
                id="detailsStringData"
                [label]="$any(item.key)"
                [value]="$any(item.value)"
              ></app-details-row>
            }
          </div>
        }
        @if (!!details?.data) {
          <div class="data-container">
            <h3>Data</h3>
            @for (item of details?.data | keyvalue; track item) {
              <app-details-row
                [label]="$any(item.key)"
                [value]="$any(item.value)"
              ></app-details-row>
            }
          </div>
        }
        @if (status !== undefined) {
          <div class="status-container">
            <div class="status-info">
              <h3>Status</h3>
              <app-help-popover
                opoverPlacement="auto"
                width="30rem"
                i18n-popoverTitle="
                  XTIT|Title of the resource
                  status@@details.status.popover.title"
                popoverTitle="Status"
                [body]="statusDescription"
              >
              </app-help-popover>
              <ng-template
                #statusDescription
                i18n="
                  YMSG|Body text of the resource status
                  popover@@details.status.popover.body"
              >
                The Ready status of a resource represents its actual state in
                relation to its desired state.
                <br /><br />
                Note that in some cases, a resource can have more than one
                condition to provide information to users and other components
                about its overall status. All conditions are listed in the
                Condition Details table.
              </ng-template>
            </div>
            <div class="status-indicator-container">
              <label fd-form-label>Ready:</label>
              <app-status
                id="detailsStatusIndicator"
                [status]="status"
                [showStatusText]="true"
                [withConditionsTable]="true"
              ></app-status>
            </div>
          </div>
        }
        @if (resource?.conditions?.length > 0) {
          <div>
            <h3>Condition Details</h3>
            <div>
              <app-statuses-table [resource]="resource"></app-statuses-table>
            </div>
          </div>
        }
        @if (annotations) {
          <div id="detailsAnnotations">
            <h3>Annotations</h3>
            @for (item of annotations | keyvalue; track item) {
              <div>
                <app-details-row
                  label="{{ item.key }}"
                  [value]="item.value"
                  [tooltip]="item.value"
                ></app-details-row>
              </div>
            }
          </div>
        }
        @if (labels) {
          <div id="detailsLabels">
            <h3>Labels</h3>
            @for (item of labels | keyvalue; track item) {
              <div>
                <app-details-row
                  label="{{ item.key }}"
                  [value]="item.value || Const.NO_VALUE_LABEL"
                  [tooltip]="item.value"
                ></app-details-row>
              </div>
            }
          </div>
        }
        @if (indices && indices.length > 0) {
          <div class="indices">
            <h3>Indices</h3>
            <app-indices-grid
              id="detailsIndices"
              [indices]="indices"
            ></app-indices-grid>
          </div>
        }
        @if (!!resource?.moveFailed) {
          <app-info-strip
            infoText="Move operation has failed."
            moreDetails="View details"
            (moreInfoClick)="openOperationDetails()"
          ></app-info-strip>
        }
      </div>
    }
    @if (detailsSelected === "yaml") {
      <div class="details-yaml-box">
        <div id="app-editor" style="width: 100%">
          @if (isYamlExpanded) {
            <app-fullscreen-head
              selector="#app-editor"
              (clickEvent)="isYamlExpanded = $event"
              [iconType]="resource.type"
              [rightHeaderContent]="headerButtons"
              [headerTitle]="resource.displayName"
            ></app-fullscreen-head>
          }
          <app-editor
            #editor
            [text]="yamlText"
            class="app-ace-editor-no-error"
            mode="yaml"
            [theme]="theme"
            [ngClass]="{
              'app-editor-standard': !isYamlExpanded,
              'app-editor-expanded': isYamlExpanded,
            }"
            [readOnly]="true"
            (onEditorInit)="initEditor($event)"
          ></app-editor>
        </div>
      </div>
    }
  </fd-busy-indicator>
</div>

<ng-template #headerButtons>
  @if (showCopyPath) {
    <button
      fd-button
      class="header-custom-icon"
      [fdCompact]="true"
      [fdType]="'transparent'"
      (click)="onCopyPath()"
    >
      Copy Path
    </button>
  }
  <button
    fd-button
    class="header-custom-icon"
    [fdCompact]="true"
    [fdType]="'transparent'"
    (click)="copyYaml()"
  >
    Copy YAML
  </button>
  @if (isEditable(resource)) {
    <button
      fd-button
      id="edit-main-actions-btn"
      class="header-custom-icon"
      (click)="this.onEditResource.emit(true)"
      [fdCompact]="true"
      [fdType]="'transparent'"
      title="Edit with YAML"
      label="Edit"
      i18n-title="XTOL|Tooltip of the Edit button@@tableExportButtonTooltip"
    ></button>
  }
  <button
    fd-button
    [fdCompact]="true"
    [fdType]="'transparent'"
    class="header-custom-icon"
    (click)="onExpandYaml()"
    label="Expand"
    title="Expand YAML"
  ></button>
  <button
    fd-button
    [fdCompact]="true"
    [fdType]="'transparent'"
    class="header-custom-icon"
    (click)="onCollapseYaml()"
    label="Collapse"
    title="Collapse YAML"
  ></button>
  <button
    fd-button
    class="refresh-fcl-button"
    class="header-custom-icon"
    i18n-title="
      XTOL|Tooltip for reload
      button@@organizations.content-details.reloadButtonTooltip"
    [fdCompact]="true"
    [disabled]="loading"
    (click)="reloadResource.emit(resource)"
    title="Refresh"
    fdType="transparent"
  >
    <app-icon icon="rotate-right" size="lg" [fixedWidth]="true"></app-icon>
  </button>
</ng-template>
